import { useCallback } from 'react';
import { trpc } from '@client-trpc';
import { TemplateType } from '@server/trading-templates/schemas/input.schema';
import { useDeleteTemplates } from './load-template/delete-templates.hook';
import { useSetDefaultTemplate } from './load-template/set-default-template';
import { useDuplicateTemplate } from './load-template/duplicate-template.hook';

export const useTemplateManagement = (templateType: TemplateType) => {
  const { onDelete } = useDeleteTemplates();
  const { onSetAsDefault } = useSetDefaultTemplate();
  const { onDuplicate } = useDuplicateTemplate();

  const { data: templates = [], isLoading } =
    trpc.tradingTemplates.tradingTemplates.useQuery({
      templateType
    });

  const handleDeleteTemplates = useCallback(
    async (templateIds: string[]) => {
      await onDelete(templateIds);
    },
    [onDelete]
  );

  const setDefaultForType = onSetAsDefault(templateType);
  const duplicateForType = onDuplicate(templateType);

  const handleToggleDefault = useCallback(
    async (templateId: string, isDefault: boolean) => {
      await setDefaultForType(templateId, isDefault);
    },
    [setDefaultForType]
  );

  const getTemplateById = useCallback(
    (templateId: string) => templates.find((template) => template.id === templateId),
    [templates]
  );

  return {
    templates,
    isLoading,
    handleDeleteTemplates,
    handleToggleDefault,
    handleDuplicateTemplate: duplicateForType,
    getTemplateById
  };
};
